export default __webpack_public_path__ + "static/media/project_3.84a77cf7.png";